import {
  SAVE_ADDRESS,
  SAVE_CONTACT,
  MODIFY_ADDRESS,
  RESET_TO_INITIAL_STATE,
  SAVE_CAR_INFO,
  RESET_DELIVERY_TYPE,
  UPDATE_CUSTOMER,
} from "../actions/actionTypes";

const initialState = {};

function convertToJS(data) {
  let d = data.replace(new RegExp("'", "g"), '"');
  d = d.replace(new RegExp("None", "g"), "null");
  d = d.replace(new RegExp("False", "g"), "false");
  d = d.replace(new RegExp("True", "g"), "true");
  return JSON.parse(d);
}

export default (state = initialState, { type, payload, asyncDispatch }) => {
  let newCustomerAddress = {};
  switch (type) {
    case "LOAD_ADDRESS_JSON":
      return {
        ...state,
        address:
          payload.address === -1
            ? undefined
            : { ...convertToJS(payload.address || "{}") },
        customerContact: {
          ...(state.customerContact || {}),
          name: payload.name,
          phone: payload.phone,
          email: payload.email || "",
        },
      };
    case "RESET_ADDRESS":
      return { ...state, address: null };
    case SAVE_CONTACT:
      return { ...state, customerContact: payload };
    case SAVE_ADDRESS:
      return {
        ...state,
        address: { ...state.address, ...payload },
      };
    case MODIFY_ADDRESS:
      return {
        ...state,
        address: { ...state.address, ...payload },
      };
    case RESET_TO_INITIAL_STATE:
      return { ...initialState };

    case SAVE_CAR_INFO:
      let newAddress = state.address;
      if (!newAddress) newAddress = {};
      if (payload.type == "make") {
        newAddress.make = payload.value;
      } else if (payload.type == "color") {
        newAddress.color = payload.value;
      } else if (payload.type == "plateNumber") {
        newAddress.plateNumber = payload.value;
      } else if (payload.type == "ebutlerRow") {
        newAddress.ebutlerRow = payload.value;
      }

      return { ...state, address: newAddress };

    case RESET_DELIVERY_TYPE:
      return {
        ...state,
        address: {
          ...state.address,
          selectedDeliveryType: undefined,
        },
      };

    case UPDATE_CUSTOMER:
      let newCustomerContact = state.customerContact || {};
      if (payload.user) {
        if (payload.require_dine_in_contact_info) {
          newCustomerContact["name"] = payload.user.name || null;
          newCustomerContact["phone"] = payload.user.phone || "";
        } else {
          newCustomerContact["name"] =
            state.customerContact?.name || payload.user.name || null;
          newCustomerContact["phone"] =
            state.customerContact?.phone || payload.user.phone || "";
        }
        newCustomerContact["email"] = payload.user.email || "";
        newCustomerContact["birth_date"] =
          state.customerContact?.birth_date || payload.user.birth_date;
      }
      newCustomerAddress = state.address;
      if (
        newCustomerAddress?.selectedDeliveryType === 0 ||
        !newCustomerAddress ||
        newCustomerAddress.selectedDeliveryType === undefined
      ) {
        // Only update if the current selected service is delivery or the user hasn't selected yet
        if (
          payload.addresses?.length &&
          payload.addresses.filter(
            (a) =>
              !a.area__is_deleted &&
              !a.area__delivery_charge__is_deleted &&
              a.area__delivery_charge__is_active
          ).length &&
          (!payload.addresses[0].branch_delivery_charge__branch__id ||
            !state.address ||
            payload.deletingAddress ||
            state.address.selectedDeliveryType === undefined) &&
          (!state.address ||
            !state.address?.block ||
            !state.address.building ||
            payload.deletingAddress ||
            state.address.selectedDeliveryType === undefined)
        ) {
          let preferredAddress =
            payload.addresses.find((a) => a.is_preferred) ||
            payload.addresses[0];
          newCustomerAddress = newCustomerAddress || {};
          newCustomerAddress = {
            ...newCustomerAddress,
            gpsConfirmed: preferredAddress.gps_confirmed || false,
            selectedDeliveryType: 0,
            selectedAddressType: 0,
            country: preferredAddress.country_id,
            area: preferredAddress.area_id,
            block:
              preferredAddress.country__name === "Qatar"
                ? preferredAddress.zone
                : preferredAddress.block,
            street: preferredAddress.street,
            building: preferredAddress.building,
            avenue: preferredAddress.avenue,
            apartment: preferredAddress.apartment,
            floor: preferredAddress.floor,
            additional: preferredAddress.additional,
            lat: parseFloat(preferredAddress.lat),
            lng: parseFloat(preferredAddress.lng),
            paci: preferredAddress.location_id,
            pickupArea: null,
          };
        } else {
          if (
            (payload.addresses.length === 0 &&
              state.address &&
              !payload.user) ||
            payload.deletingAddress
          ) {
            // coming from deleting address
            // This means all the addresses have been deleted. Reset the address
            newCustomerAddress = null;
          } else newCustomerAddress = state.address;
        }
      }
      return {
        ...state,
        customerContact: newCustomerContact,
        address: newCustomerAddress,
      };

    case "SWITCH_ADDRESS":
      newCustomerAddress = state.address;
      newCustomerAddress = {
        ...newCustomerAddress,
        gpsConfirmed: payload.address.gps_confirmed || false,
        selectedDeliveryType: 0,
        selectedAddressType:
          !!payload.address.apartment || !!payload.address.floor ? 1 : 0,
        country: payload.address.country_id,
        area: payload.address.area_id,
        block:
          payload.address.country__name === "Qatar"
            ? payload.address.zone
            : payload.address.block,
        street: payload.address.street,
        building: payload.address.building,
        avenue: payload.address.avenue,
        apartment: payload.address.apartment,
        floor: payload.address.floor,
        additional: payload.address.additional,
        lat: parseFloat(payload.address.lat) || null,
        lng: parseFloat(payload.address.lng) || null,
        paci: payload.address.location_id,
        pickupArea: null,
      };
      return {
        ...state,
        address: newCustomerAddress,
      };

    case "CLEAR_ADDRESS": // Used when adding a new address from BranchSelect.js (auth)
      return { ...state, address: { selectedDeliveryType: 0 } };

    case "EDIT_CUSTOMER_PHONE":
      return {
        ...state,
        customerContact: { ...state.customerContact, phone: payload },
      };
    case "RESET_ADDRESS_FOR_UNKNOWN_GIFT_LOCATION": {
      let newAddress = state?.address;
      newAddress = {
        ...newAddress,
        block: "",
        street: "",
        building: "",
        avenue: "",
        apartment: "",
        floor: "",
        additional: "",
        paci: "",
      };
      return {
        ...state,
        address: newAddress,
      };
    }

    case "SET_CUSTOMER_BIN":
      return { ...state, bin: payload };

    case "RESET_CUSTOMERS_REDUCER":
      return { ...state, customerContact: null, address: null };

    default:
      return state;
  }
};
